<div class="card" [formGroup]="recordForm" *ngIf="recordForm">
    <p-table [value]="datasource" [sortField]="groupColumnName" sortMode="single" [dataKey]="groupColumnName"
        rowGroupMode="subheader" [groupRowsBy]="groupColumnName" [tableStyle]="{'min-width': '70rem'}" dataKey="id" [scrollable]="true" scrollHeight="350px">
        <ng-template pTemplate="header">
            <tr>
                <th *ngFor="let item of header" pSortableColumn={{item.key}}>
                    <div class="t-title-icon"> 
                          <span> {{item.title}}</span>
                          <p-sortIcon field={{item.key}} [ngStyle]="{'display': (item.key == 'action' ) ? 'none': (item.key == 'status') ? 'none' :'inline-block'}"></p-sortIcon>
                    </div>
                </th>
            </tr>
        </ng-template>
        <ng-template pTemplate="groupheader" let-data let-rowIndex="rowIndex" let-expanded="expanded">
            <tr>
                <td [attr.colspan]="header.length + 1">
                    <div class="h-100 d-flex align-items-center">
                        <button style="width: 2rem; height: 2rem;" type="button" pButton pRipple [pRowToggler]="data"
                            class="p-button-text p-button-rounded p-button-plain me-3 p-0"
                            [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'">
                        </button>
                        <span class="fw-bold ml-2">{{data.categoryName?.toString().toUpperCase()}}</span>
                    </div>
                </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="groupfooter" let-data>
            <tr class="p-rowgroup-footer">
                <td [attr.colspan]="header.length" style="text-align: right">Total Records
                    <div class="fw-bold text-primary4">{{calculatedataTotal(data.categoryName)}}</div></td>
            </tr>
        </ng-template>
        <ng-template pTemplate="rowexpansion" let-data let-i="rowIndex" let-editing="editing" formArrayName="record">
            <tr [formGroupName]="i">
                <ng-container *ngFor="let key of header">
                    <td *ngIf="key.key != 'action' && key.editable" [pEditableColumn]="data[key.key]"
                        [pEditableColumnField]="key.key">
                        <input pInputText type="text" [(ngModel)]="data[key.key]" [ngModelOptions]="{standalone: true}"
                            (input)="onChange($event, i, key.key, data)"
                            onKeyPress="if(this.value.length==10) return false;"
                            [ngClass]="{'border-danger':(records.get([i, key.key])?.invalid && (records.get([i, key.key])?.touched || records.get([i, key.key])?.dirty))}" />
                    </td>
                    <td *ngIf="!key.editable && key.key != 'action' && !key.currencyPipe">{{ data[key.key]?.toString().toUpperCase() }}</td>
                    <td *ngIf="!key.editable && key.key != 'action' && key.currencyPipe">{{ data[key.key] | currency : ' ' : 'symbol-narrow' : '1.2-2'}}</td>
                    <td *ngIf="key.key == 'action'">
                        <ul class="action-icons">
                            <li class="overflow-hidden">
                                <button (click)="onDelete(data)">
                                    <p-iconField iconPosition="left">
                                        <p-inputIcon styleClass="pi pi-trash text-danger" />
                                    </p-iconField>
                                </button>
                            </li>
                        </ul>
                    </td>
                </ng-container>
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
            <!-- <div class="nodata" [attr.colspan]="Data?.length"> -->
            <tr *ngIf="!loader">
                <td [attr.colspan]="header.length +1">
                    <div class="nodata">
                        <div class="not-found py-4 w-100 text-center">
                            <img src="assets/images/no-data.png" alt="">
                            <span class="mt-4 d-block">No data available</span>
                        </div>
                    </div>
                </td>
            </tr>
        </ng-template>

    </p-table>
</div>
<div class="card" *ngIf="!recordForm">
    <p-table [value]="datasource" [sortField]="groupColumnName" sortMode="single" [dataKey]="groupColumnName"
        rowGroupMode="subheader" [groupRowsBy]="groupColumnName" [tableStyle]="{'min-width': '70rem'}" dataKey="id" [scrollable]="true" scrollHeight="350px">
        <ng-template pTemplate="header">
            <tr>
                <th *ngFor="let item of header" pSortableColumn={{item.key}}>
                    <div class="t-title-icon"> 
                        <span> {{item.title}}</span>
                        <p-sortIcon field={{item.key}} [ngStyle]="{'display': (item.key == 'action' ) ? 'none': (item.key == 'status') ? 'none' :'inline-block'}"></p-sortIcon>
                    </div>
                </th>
            </tr>
        </ng-template>
        <ng-template pTemplate="groupheader" let-data let-rowIndex="rowIndex" let-expanded="expanded">
            <tr>
                <td [attr.colspan]="header.length + 1">
                    <div class="h-100 d-flex align-items-center">
                        <button style="width: 2rem; height: 2rem;" type="button" pButton pRipple [pRowToggler]="data"
                            class="p-button-text p-button-rounded p-button-plain me-3 p-0"
                            [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'">
                        </button>
                        <span class="fw-bold ml-2">{{data.categoryName?.toString().toUpperCase()}}</span>
                    </div>
                </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="groupfooter" let-data>
            <tr class="p-rowgroup-footer">
                <td [attr.colspan]="header.length" style="text-align: right">Total Records
                    <div class="fw-bold text-primary4">{{calculatedataTotal(data.categoryName)}}</div></td>
            </tr>
        </ng-template>
        <ng-template pTemplate="rowexpansion" let-data let-i="rowIndex" let-editing="editing">
            <tr>
                <ng-container *ngFor="let key of header">
                    <td *ngIf="key.key != 'action' && key.editable" [pEditableColumn]="data[key.key]"
                        [pEditableColumnField]="key.key">
                        <input pInputText type="text" [(ngModel)]="data[key.key]"  onKeyPress="if(this.value.length==10) return false;"
                        (input)="onChange($event, i, key.key, data)" />
                    </td>
                    <td *ngIf="!key.editable && key.key != 'action' && !key.currencyPipe">{{ data[key.key]?.toString().toUpperCase() }}</td>
                    <td *ngIf="!key.editable && key.key != 'action' && key.currencyPipe">{{ data[key.key] | currency : ' ' : 'symbol-narrow' : '1.2-2'}}</td>
                    <td *ngIf="key.key == 'action'">
                        <ul class="action-icons">
                            <li class="overflow-hidden">
                                <button (click)="onDelete(data)">
                                    <p-iconField iconPosition="left">
                                        <p-inputIcon styleClass="pi pi-trash text-danger" />
                                    </p-iconField>
                                </button>
                            </li>
                        </ul>
                    </td>
                </ng-container>
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
            <!-- <div class="nodata" [attr.colspan]="Data?.length"> -->
            <tr>
                <td [attr.colspan]="header.length +1">
                    <div class="nodata">
                        <div class="not-found py-4 w-100 text-center">
                            <img src="assets/images/no-data.png" alt="">
                            <span class="mt-4 d-block">No data available</span>
                        </div>
                    </div>
                </td>
            </tr>
        </ng-template>

    </p-table>
</div>